<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="25"
    viewBox="0 0 39 25"
    fill="none"
  >
    <path
      d="M31.5672 24.1875C35.1751 24.1875 38.1 21.3915 38.1 17.9424C38.1 14.4933 35.1751 11.6972 31.5672 11.6972C31.4019 11.6972 31.238 11.7032 31.0759 11.7147C31.0837 11.5538 31.0878 11.3917 31.0878 11.2288C31.0878 5.5796 26.2973 1 20.3876 1C15.336 1 11.1021 4.34642 9.9793 8.84695C9.67439 8.81358 9.36426 8.79638 9.05015 8.79638C4.6041 8.79638 1 12.2417 1 16.4919C1 20.7422 4.6041 24.1875 9.05015 24.1875H31.5672Z"
      fill="white"
      stroke="#90A0B7"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.8585 13.3295L19.5474 9.20822"
      stroke="#90A0B7"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.2354 13.3295L19.5465 9.20822"
      stroke="#90A0B7"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5474 9.22563V19.7167"
      stroke="#90A0B7"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: 'UploadIconGrey',
}
</script>
